/* global jQuery, PubSub, Namespace */
(function ($, PubSub, ns) {
    'use strict';

    ns.TOPIC_NAMES = ns.TOPIC_NAMES || {};

    $.extend(true, ns.TOPIC_NAMES, {
        AUTO_COMPLETE_DATA: 'auto_complete_data',
        Request: {
            REQUEST: {
                INVALID_FORM: 'request.invalidForm',
                INVALID_FORM_PHONE: 'request.invalidPhone',
                REPEATED_REQUEST: 'request.repeatedRequest',
                DISTANCE_EXCEEDED: 'request.distanceExceeded',

                SIMILAR_COMPANIES_RECEIVED: 'request.similarCompaniesReceived',
                VALIDATE: {
                    INVALID_HANDLER: 'request.validate.invalid_handler'
                },

                RESPONSE: {
                    // Success
                    SUCCESS: 'request.response.success',
                    SUCCESS_PRODUCT: 'request.response.product',
                    SUCCESS_AUTO_VALIDATED: 'request.response.autoValidated',

                    // Business logic
                    UNDETERMINED_POPULATION: 'request.response.undeterminedPopulation',
                    LIMIT_EXCEEDED: 'request.response.limitExceeded',
                    REPEATED_REQUEST: 'request.response.repeatedRequest',
                    EXCEED_DISTANCE: 'request.response.exceedDistance',
                    NOT_SAME_PROVINCE: 'request.response.notSameProvince',
                    INVALID_PROVINCE: 'request.response.invalidProvince',

                    // Format:
                    INVALID_PHONE: 'request.response.invalidPhone',
                    INVALID_POPULATION: 'request.response.invalidPopulation',

                    UNDEFINED_ERROR: 'request.response.undefinedError'
                },

                STEP_RESPONSE: {
                    VISUAL_SELECTION: 'request.response.visualSelection',
                    DIRECT_WITH_SERVICE: 'request.response.directWithService',
                    SAVED: 'request.response.saved',
                    TO_NEXT_STEP: 'request.response.toNextStep'
                }
            },
            APPOINTMENT: {
                APPOINTMENT_SELECTED: 'appointment.appointment.selected',
                VIDEOCALL_SELECTED: 'appointment.videocall.selected'
            },

            SENT_INVALID_REQUEST: 'request.invalidHandler',
            SENT_INVALID_REQUEST_PROVINCE: 'request.invalidProvince'
        },
        USER_REFRESH_NOTIFICATIONS: 'user.refresh_notifications',
        HOME: {
            UPDATE_SERVICE_SELECT: 'iempresas.home.update_service_select',
            UPDATE_SERVICE_SELECT_SUCCESS: 'iempresas.home.update_service_select_success',
            UPDATE_LOCATION_SELECT: 'iempresas.home.update_location_select',
            UPDATE_LOCATION_SELECT_SUCCESS: 'iempresas.home.update_location_select_success'
        },
        STATIC: {
            ASK_FOR_CONTACT: 'iempresas.static.ask_for_contact',
            ASK_FOR_CONTACT_SUCCESS: 'iempresas.static.ask_for_contact_success'
        },
        ARTICLE: {
            // Article post new comment
            ARTICLE_COMMENT_POST: 'iempresas.article.post_comment',
            ARTICLE_COMMENT_POST_SUCCESS: 'iempresas.article.post_comment_success',
            ARTICLE_COMMENT_POST_ERROR: 'iempresas.article.post_comment_error',
            // Article request more comments
            ARTICLE_MORE_COMMENTS: 'iempresas.article.more_comments',
            ARTICLE_MORE_COMMENTS_SUCCESS: 'iempresas.article.more_comments_success'
        },
        QANDA: {
            LOGIN_REQUIRED: 'iempresas.qanda.login_required',
            // Suggest similar questions
            GET_SIMILAR_QUESTIONS: 'iempresas.qanda.get_similar_questions',
            GET_SIMILAR_QUESTIONS_SUCCESS: 'iempresas.qanda.get_similar_questions_success',
            // Create question form
            POST_NEW_QUESTION: 'iempresas.qanda.post_new_question',
            POST_NEW_QUESTION_SUCCESS: 'iempresas.qanda.post_new_question_success',
            POST_NEW_QUESTION_ERROR: 'iempresas.qanda.post_new_question_error',
            POST_NEW_QUESTION_FORM_ERROR: 'iempresas.qanda.post_new_question_form_error',
            // Answer question
            GET_ANSWER_DIALOGS: 'iempresas.qanda.get_answer_dialogs',
            GET_ANSWER_DIALOGS_SUCCESS: 'iempresas.qanda.get_answer_dialogs_success',
            GET_ANSWER_DIALOGS_ERROR: 'iempresas.qanda.get_answer_dialogs_error',
            SAVE_ANSWER: 'iempresas.qanda.save_answer_request',
            SAVE_ANSWER_SUCCESS: 'iempresas.qanda.save_answer_success',
            SAVE_ANSWER_ERROR: 'iempresas.qanda.save_answer_error',
            // Like answer
            LIKE_ANSWER: 'iempresas.qanda.like_answer_request',
            LIKE_ANSWER_SUCCESS: 'iempresas.qanda.like_answer_success'
        },
        PRODUCT: {
            SAVE_ANONYMOUS_USERS_DATA: 'iempresas.product.save_anonymous_users_data',
            CHECK_USER_TYPE: 'iempresas.product.check_user_type'
        },
        REVIEW: {
            INITIALIZE: 'iempresas.review.initialize',
            INITIALIZE_SUCCESS: 'iempresas.review.initialize_success',
            CREATE_REVIEW: 'iempresas.review.create_review',
            CREATE_REVIEW_SUCCESS: 'iempresas.review.create_review_success',
            NO_CONTRACT_REASON: 'iempresas.review.no_contract_reason',
            CONTRACTED_RATINGS: 'iempresas.review.contracted_ratings',
            SHOW_RECOMMENDATION_COMMENT: 'iempresas.review.show_recommendation_comment',
            SAVE_COMMENT: 'iempresas.review.save_comment',
            SHOW_LOGIN: 'iempresas.review.show_login',
            LOGIN: 'iempresas.review.login',
            SHOW_SUCCESS_GOAL: 'iempresas.review.show_success_goal'
        },
        CATALOG: {
            GET_CATEGORY_SUB_LEVEL: 'iempresas.catalog.get_category_sub_level',
            GET_CATEGORY_SUB_LEVEL_SUCCESS: 'iempresas.catalog.get_category_sub_level_success'
        },
        SESSION_NAVIGATION: {
            SET: 'session_navigation.set'
        }
    });

    ns.CONSTS = ns.CONSTS || {
        SWIPER_PATH: '/js/vendor/swiper/dist/js/swiper.jquery.min.js',
        J_CROP: '/js/vendor/Jcrop/js/jquery.Jcrop.min.js'
    };

    /**
     * Check if is development environment.
     * @returns {*}
     */
    function isDev() {
        var virtualMachine = '.vm',
            hostName = window.location.hostname;
        return hostName.indexOf(virtualMachine) > -1;
    }

    $(document).ready(function () {
        if (isDev()) {
            PubSub.subscribe('iempresas', function (msg, data) {
                console.info('TOPIC:', msg, data);
            });
            PubSub.subscribe('request', function (msg, data) {
                console.info('TOPIC:', msg, data);
            });
            PubSub.subscribe('auto_complete_data', function (msg, data) {
                console.info('TOPIC:', msg, data);
            });
        }
    });

}(jQuery, PubSub, Namespace));
